module.exports = __webpack_public_path__ + "img/guy1.1d42fcc.png";